import { render, staticRenderFns } from "./AccountBalanceReportCreate.vue?vue&type=template&id=835a2720"
import script from "./AccountBalanceReportCreate.vue?vue&type=script&lang=js"
export * from "./AccountBalanceReportCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports